import { Action, createAction, props, union } from '@ngrx/store';
import {
  zefActionFailPayload,
  zefActionPayload,
  zefActionSuccessPayload
} from '@zerops/zef/core';
import {
  ResourceConsumptionGroupRequestPayload,
  ResourceConsumptionGroupUpdateSuccessPayload
} from './resource-consumption-base.model';

export const trackResourceConsumptionGroupItem = createAction(
  '[@zerops/zerops/core/resource-consumption-base] track-resource-consumption-group-item',
  props<{ data: Action; }>()
);

export const resourceConsumptionGroupPrefillData = createAction(
  '[@zerops/zerops/core/resource-consumption-base] resource-consumption-group-prefill-data',
  props<ResourceConsumptionGroupUpdateSuccessPayload>()
);

export const resourceConsumptionGroup = createAction(
  '[@zerops/zerops/core/resource-consumption-base] resource-consumption-group',
  zefActionPayload<ResourceConsumptionGroupRequestPayload>()
);

export const resourceConsumptionGroupCancel = createAction(
  '[@zerops/zerops/core/resource-consumption-base] resource-consumption-group/cancel',
  zefActionPayload
);

export const resourceConsumptionGroupFail = createAction(
  '[@zerops/zerops/core/resource-consumption-base] resource-consumption-group/fail',
  zefActionFailPayload
);

export const resourceConsumptionGroupSuccess = createAction(
  '[@zerops/zerops/core/resource-consumption-base] resource-consumption-group/success',
  zefActionSuccessPayload<ResourceConsumptionGroupUpdateSuccessPayload>()
);

export const resourceConsumptionGroupUpdate = createAction(
  '[@zerops/zerops/core/resource-consumption-base] resource-consumption-group/update',
  props<ResourceConsumptionGroupUpdateSuccessPayload>()
);

const all = union({
  resourceConsumptionGroup,
  resourceConsumptionGroupCancel,
  resourceConsumptionGroupFail,
  resourceConsumptionGroupSuccess,
  resourceConsumptionGroupUpdate,
  trackResourceConsumptionGroupItem
});

export type ResourceConsumptionBaseActionUnion = typeof all;